<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (comparisonObjects)="getComparisonObjects($event)"
>
  <!---------------------------------------- Table Content ---------------------------------------->
  <ng-container table-body *ngIf="roleOrganizations && !pageConfig.loading">
    <ng-container *ngFor="let item of roleOrganizations; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        class="tw-ml-2"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">{{ i + 1 }}</td>

        <!-- name -->
        <td>
          <td-value copyToClipboard [value]="item?.name"></td-value>
        </td>

        <td class="sticky-td">
          <a
            (click)="onSelect(item?.id)"
            class="btn btn-sm"
            [matTooltip]="'common.users' | translate"
          >
            <i
              class="mdi mdi-account-group mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-info"
              [class]="loading ? 'opacity-5' : ''"
            ></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!roleOrganizations?.length" table-body>
    <tr>
      <td colspan="100">
        <p
          class="tw-text-center tw-text-gray-500 dark:tw-text-gray-300 tw-my-5 tw-text-lg tw-dir-rtl ltr:tw-dir-ltr"
        >
          {{ "common.empty" | translate }}
        </p>
      </td>
    </tr>
  </ng-container>
</app-page-template>
